//创建options数据
export const buildOptionsData = (data: any) => {
  const o: any = [];
  if (!data.length) return o;
  data.map((item: any) => {
    o.push({
      id: item._id || item.cas,
      label: `${item.Name_ZH} ${item.Molecular_formula}`,
      value: `${item.Name_ZH}${item.Molecular_formula}`,
      formula: `${item.Molecular_formula}`,
      alias: item.alias,
      description: item.description,
      type: item.Type,
      name: item.Name_ZH,
      ename: item.Name_EN,
      cas_code: item.cas,
      properties: "",
    });
  });
  return o;
};